import { useCallback, useEffect, useState } from 'react';
import { ChatNavigatorItem } from './ChatNavigator.type';

/**
 * Holds the navigator's lightweight full-thread index of user turns. The data
 * source is injected so any chat surface can supply its own endpoint; pass
 * null to disable (the rail hides itself on an empty index). `refresh` lets
 * the caller re-sync after sends, streaming end, or checkpoint reverts.
 */
export function useChatIndex(fetchIndex: (() => Promise<ChatNavigatorItem[]>) | null) {
  const [items, setItems] = useState<ChatNavigatorItem[]>([]);

  const refresh = useCallback(async () => {
    if (!fetchIndex) {
      setItems([]);
      return;
    }
    try {
      setItems((await fetchIndex()) || []);
    } catch (error) {
      // Non-fatal: the rail just stays stale/hidden
      console.error('Failed to load chat navigator index:', error);
    }
  }, [fetchIndex]);

  useEffect(() => {
    setItems([]);
    refresh();
  }, [refresh]);

  return { items, refresh };
}
